import { render } from "./MQuestionnaire.vue?vue&type=template&id=73494ac9&scoped=true&ts=true"
import script from "./MQuestionnaire.vue?vue&type=script&lang=ts"
export * from "./MQuestionnaire.vue?vue&type=script&lang=ts"

import "./MQuestionnaire.vue?vue&type=style&index=0&id=73494ac9&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/campaign-widget/campaign-widget/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73494ac9"]])

export default __exports__